import React from 'react';
import PropTypes from 'prop-types';
import { ALPHABETIC_REGEX } from '../utils/constants';
import { PatternInput } from './PatternInput';

export const AlphabeticInput = React.forwardRef(({ onChange, value, ...props }, ref) => {
  return (
    <PatternInput
      {...props}
      ref={ref}
      value={value}
      onChange={onChange}
      pattern={ALPHABETIC_REGEX}
      inputMode='text'
    />
  );
});

AlphabeticInput.displayName = 'AlphabeticInput';

AlphabeticInput.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
};
